module.exports = __webpack_public_path__ + "static/media/Artboard3.0eb71be3.png";